// utils/auth.js

import { initTradeDeviceMeta } from './tradeDeviceMeta';

export const AUTH_MESSAGE_KEY = 'appAuthMessage';
export const SESSION_EXPIRED_EVENT = 'app-session-expired';
export const SESSION_EXPIRED_LOCK_KEY = 'appSessionExpiredLock';

let handlingSessionExpired = false;
let sessionExpiredDialogOpen = false;
let sessionExpiredUI = null;

const setCookie = (name, value, days) => {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = `${name}=${value}; ${expires}; path=/`;
};

const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
};

function clearSessionExpiredLock() {
  try {
    sessionStorage.removeItem(SESSION_EXPIRED_LOCK_KEY);
  } catch (e) {}
  try {
    localStorage.removeItem(SESSION_EXPIRED_LOCK_KEY);
  } catch (e) {}
}

function persistSessionExpiredLock(displayMessage) {
  const payload = JSON.stringify({ message: displayMessage, at: Date.now() });
  try {
    sessionStorage.setItem(SESSION_EXPIRED_LOCK_KEY, payload);
  } catch (e) {}
  try {
    localStorage.setItem(SESSION_EXPIRED_LOCK_KEY, payload);
  } catch (e) {}
}

export const storeToken = async (data) => {
    clearSessionExpiredLock();
    handlingSessionExpired = false;
    sessionExpiredDialogOpen = false;

    localStorage.setItem('authToken', data.token);
    localStorage.setItem('userId', data.clientId);

    setCookie('appilix_push_notification_user_identity', data.clientId, 30); // '30' is for 30 days
    initTradeDeviceMeta({ clientId: data.clientId, prefetchFcm: true });
  };
  
  export const getToken = async () => {
    const token = localStorage.getItem('authToken');
    //console.log("token read: ", token);
    return token ? token : null;
  };
  
  export const removeToken = async () => {
    localStorage.removeItem('authToken');
  };

let cachedAuthMessage;
let authMessageRead = false;

export function consumeAuthMessage() {
  if (!authMessageRead) {
    authMessageRead = true;
    try {
      cachedAuthMessage = sessionStorage.getItem(AUTH_MESSAGE_KEY) || localStorage.getItem(AUTH_MESSAGE_KEY) || '';
      if (cachedAuthMessage) {
        sessionStorage.removeItem(AUTH_MESSAGE_KEY);
        localStorage.removeItem(AUTH_MESSAGE_KEY);
      }
    } catch (e) {
      cachedAuthMessage = '';
    }
  }
  return cachedAuthMessage || '';
}

export function friendlySessionExpiredMessage(message) {
  const text = message ? String(message).trim() : '';
  if (text && /please login again/i.test(text)) {
    return text;
  }
  return 'Session expired. Please login again.';
}

export function setSessionExpiredUI(handler) {
  sessionExpiredUI = typeof handler === 'function' ? handler : null;
}

export function restoreSessionExpiredLock() {
  try {
    const raw = sessionStorage.getItem(SESSION_EXPIRED_LOCK_KEY) || localStorage.getItem(SESSION_EXPIRED_LOCK_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    if (parsed && parsed.message) {
      sessionExpiredDialogOpen = true;
      return parsed;
    }
  } catch (e) {}
  return null;
}

function persistAuthMessage(displayMessage) {
  try {
    sessionStorage.setItem(AUTH_MESSAGE_KEY, displayMessage);
  } catch (e) {}
  try {
    localStorage.setItem(AUTH_MESSAGE_KEY, displayMessage);
  } catch (e) {}
}

function clearAuthStorage() {
  localStorage.removeItem('authToken');
  localStorage.removeItem('userId');
  localStorage.removeItem('initSetupDone');
  localStorage.removeItem('parentId');
}

function hardRedirectToLogin() {
  const origin = window.location.origin || '';
  const next = origin + '/login?session=expired&t=' + Date.now();
  try {
    window.location.href = next;
  } catch (e) {
    try {
      window.location.assign(next);
    } catch (err) {
      window.location.reload();
    }
  }
}

export function notifySessionExpired(message) {
  if (sessionExpiredDialogOpen || handlingSessionExpired) {
    return;
  }
  sessionExpiredDialogOpen = true;

  const displayMessage = friendlySessionExpiredMessage(message);
  persistSessionExpiredLock(displayMessage);

  if (typeof sessionExpiredUI === 'function') {
    sessionExpiredUI(displayMessage);
    return;
  }

  try {
    window.dispatchEvent(
      new CustomEvent(SESSION_EXPIRED_EVENT, { detail: { message: displayMessage } })
    );
  } catch (e) {}

  window.setTimeout(function () {
    if (handlingSessionExpired) {
      return;
    }
    try {
      window.alert(displayMessage);
    } catch (e) {}
    logoutDueToExpiredSession(displayMessage);
  }, 250);
}

export function logoutDueToExpiredSession(message) {
  if (handlingSessionExpired) {
    return;
  }
  handlingSessionExpired = true;
  sessionExpiredDialogOpen = true;

  const displayMessage = friendlySessionExpiredMessage(message);
  persistAuthMessage(displayMessage);
  clearSessionExpiredLock();
  clearAuthStorage();
  hardRedirectToLogin();
}
